export default __webpack_public_path__ + "static/media/download.f8b8d36d.svg";